<template>
    <footer class="app-footer">
        <div class="container-fluid footer-p">
            <b-row align-v="center" align-h="between">
                <b-col cols="6">
                    <h3 class="footer-content footer-heading">
                        Trung tâm Quy hoạch và Điều tra Tài nguyên nước quốc gia
                    </h3>
                    <h5 class="footer-content content-spacing">
                        &copy; GIS Team {{ $moment().format('YYYY') }}
                    </h5>
                </b-col>
                <b-col cols="6">
                    <div class="footer-icons">
                        <a href>
                            <i class="fa fa-facebook"></i>
                        </a>
                        <a href>
                            <i class="fa fa-youtube"></i>
                        </a>
                        <a href>
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </b-col>
            </b-row>
        </div>
    </footer>
</template>
<script>
export default {
    name: 'c-footer'
};
</script>
<style lang="scss" scoped>
.app-footer {
    height: 250px;
    width: 100%;
    background: url('@/assets/footer-banner.jpg') center no-repeat;
    background-size: 100 100%;

    .footer-content {
        color: white;
        font-weight: 600;
    }

    .footer-icons {
        margin-top: 25px;
        text-align: right;

        a {
            display: inline-block;
            width: 35px;
            height: 35px;
            cursor: pointer;
            background-color: rgba(123, 192, 248, 0.753);
            border-radius: 50%;
            font-size: 20px;
            color: #ffffff;
            text-align: center;
            line-height: 35px;
            margin-right: 10px;
            margin-bottom: 5px;
        }
    }
}

@media screen and (min-width: 1025px) {
    .footer-p {
        padding: 50px 100px;

        .content-spacing {
            margin-top: 1.5rem !important;
        }
    }
}

@media screen and (max-width: 500px) {
    .footer-p {
        padding: 10px;

        .footer-content {
            font-size: 1rem;
        }

        .footer-heading {
            font-size: 1.25rem;
        }

        .content-spacing {
            margin-top: 0rem !important;
        }
    }
}
</style>
